import React from "react";
import { Grid, Typography, Stack, Link } from "@mui/material";
import Chris from "../images/photo.jpg";
import Typewriter from "typewriter-effect";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ScrollDown from "./ScrollDown";

const Hero = () => {
  return (
    <article>
      <Grid item sx={{ height: { xs: "95vh", md: "80vh" } }}
        container
        direction="column"
        justifyContent="center"
        height="100vh"
        // marginBottom="200px"
        id="home"
      >
        <Grid item sx={{ height: { xs: "45vh", md: "130vh" } }}>
          <Grid
            container
            spacing={5}
            justifyContent={{ xs: "space-evenly", md: "space-evenly" }}
            alignItems="center"
            flexDirection={{ xs: "column-reverse", md: "row" }}
          >
            <Grid item>
              <Typography
                component="div"
                sx={{
                  mb: { xs: 2, md: 5 },
                  fontSize: { xs: "1.5rem", md: "2rem" },
                }}
                color="primary"
              >
                Hey, I'm
              </Typography>
              <Typography
                variant="h2"
                component="div"
                sx={{
                  mb: { xs: 2, md: 5 },
                  fontSize: { xs: "3rem", md: "4rem" },
                }}
              >
                Ravulapalli Sireesha
              </Typography>
              <Typography
                variant="h3"
                component="div"
                sx={{
                  mb: { xs: 2, md: 5 },
                  fontSize: { xs: "2rem", md: "3rem" },
                }}
                color="primary"
              >
                Learning | Full Stack Web Devolpment. 
              </Typography>
              <Typography
                variant="h4"
                component="div"
                sx={{
                  mb: { xs: 2, md: 5 },
                  fontSize: { xs: "1.5rem", md: "2rem" },
                  fontFamily: "Monospace",
                }}
              >
                I use
                <Typewriter
                  options={{
                    strings: ["Html","Css","JavaScript", "React","Next.js"],
                    autoStart: true,
                    loop: true,
                  }}
                />
              </Typography>
              <Stack
                spacing={2}
                direction="row"
                justifyContent={{ xs: "center", md: "flex-start" }}
              >
                <Link
                  href="#about"
                  underline="none"
                  sx={{
                    fontSize: "1rem",
                    fontWeight: "500",
                    width: "150px",
                    color: "#9b63ff",
                    textTransform: "uppercase",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "1px solid rgba(103, 58, 183, 0.5)",
                    borderRadius: "5px",
                    padding: "0px 15px",
                    transition:
                      "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                    "&:hover": {
                      background: "rgba(103, 58, 183, 0.08)",
                      border: "1px solid #9b63ff",
                    },
                  }}
                >
                  About me <ArrowForwardIosIcon fontSize="1rem" />
                </Link>
                <Link
                  href="#portfolio"
                  underline="none"
                  sx={{
                    background: "#5774FF",
                    fontSize: "1rem",
                    fontWeight: "500",
                    width: "150px",
                    color: "black",
                    textTransform: "uppercase",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "5px",
                    padding: "5px 15px",
                    transition:
                      "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                    "&:hover": {
                      background: "#7574FF",
                    },
                  }}
                >
                  My works <ArrowForwardIosIcon fontSize="1rem" />
                </Link>
              </Stack>
            </Grid>
            <Grid item sx={{ height: { xs: "300px", md: "500px" } }}>
              <img src={Chris} alt="Chris Z." style={{ height: "80%" ,borderRadius:"50%"}} />
              </Grid>
          </Grid>
        </Grid>
        <ScrollDown />
      </Grid>
    </article>
  );
};

export default Hero;
